"use client";

import React from "react";
import LeftTopSection from "./LeftTopSection";
import MiddleTopSection from "./MiddleTopSection";
import RightTopSection from "./RightTopSection";
import ServicesSection from "./ServicesSection";
import BuildingTogether from "./BuildingTogether";
import WhatWeDo from "./WhatWeDo";
import OurWorkSection from "./OurWork";
import About from "./About";
import MobileOurWorkSection from "./OurWork/mobile/MobileOurWorkSection";
import MobileServicesSection from "./MobileServicesSection";
import { FAQSection } from "./FAQ";
import { usePathname, useRouter } from "next/navigation";
const LandingPage = () => {
  // navigation fixed for deployment
  const router = useRouter();
  const pathname = usePathname();

  if (router && pathname.includes("cost-calculator")) {
    router.push("/cost-calculator");
  }
  if (router && pathname.includes("cookies-policy")) {
    router.push("/cookies-policy");
  }
  if (router && pathname.includes("privacy-policy")) {
    router.push("/privacy-policy");
  }
  if (router && pathname.includes("terms-of-use")) {
    router.push("/terms-of-use");
  }

  return (
    <div id="home" className="w-full flex-col flex items-center justify-center">
      <div className="max-w-[1357px] w-full max-h-min flex flex-col sm:flex-row gap-6">
        <div className="order-1 sm:order-none">
          <LeftTopSection />
        </div>
        <div className="order-3 sm:order-none sm:my-auto">
          <MiddleTopSection />
        </div>
        <div className="order-2 sm:order-none">
          <RightTopSection />
        </div>
      </div>
      <ServicesSection />
      <MobileServicesSection />
      <OurWorkSection />
      <MobileOurWorkSection />
      <BuildingTogether />
      <WhatWeDo />
      <FAQSection />
      <About />
    </div>
  );
};

export default LandingPage;
